module.exports = __webpack_public_path__ + "src/assets/img/favicon.5d0fc53a.svg";